module.exports = __webpack_public_path__ + "static/img/LOGO_bms.4819b327.svg";